import { Unit, UnitPrefix, BaseUnits } from "uom";
// Duration / Time
export var Minute = Unit.timesNumber("Minute", 60.0, BaseUnits.Second);
export var Hour = Unit.timesNumber("Hour", 60.0, Minute);
export var Day = Unit.timesNumber("Day", 24.0, Hour);
export var Week = Unit.timesNumber("Week", 7.0, Day);
export var Year = Unit.timesNumber("Year", 8760.0, Hour);
export var MilliSecond = UnitPrefix.Milli("MilliSecond", BaseUnits.Second);
//# sourceMappingURL=duration.js.map